import { render, staticRenderFns } from "./SfMenuItem.vue?vue&type=template&id=9977ff80"
import script from "./SfMenuItem.vue?vue&type=script&lang=js"
export * from "./SfMenuItem.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfMenuItem.vue?vue&type=style&index=0&id=9977ff80&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "2145ea12"
  
)

export default component.exports